var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYears(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0C29.5953 0 32.5 2.59746 32.5 5.8125V11.625H58.5V5.8125C58.5 2.59746 61.4047 0 65 0C68.5953 0 71.5 2.59746 71.5 5.8125V11.625H81.25C86.6328 11.625 91 15.5303 91 20.3438V29.0625H0V20.3438C0 15.5303 4.36719 11.625 9.75 11.625H19.5V5.8125C19.5 2.59746 22.4047 0 26 0ZM0 34.875H91V84.2812C91 89.0947 86.6328 93 81.25 93H9.75C4.36719 93 0 89.0947 0 84.2812V34.875ZM13 49.4062V55.2188C13 56.8172 14.4625 58.125 16.25 58.125H22.75C24.5375 58.125 26 56.8172 26 55.2188V49.4062C26 47.8078 24.5375 46.5 22.75 46.5H16.25C14.4625 46.5 13 47.8078 13 49.4062ZM39 49.4062V55.2188C39 56.8172 40.4625 58.125 42.25 58.125H48.75C50.5375 58.125 52 56.8172 52 55.2188V49.4062C52 47.8078 50.5375 46.5 48.75 46.5H42.25C40.4625 46.5 39 47.8078 39 49.4062ZM68.25 46.5C66.4625 46.5 65 47.8078 65 49.4062V55.2188C65 56.8172 66.4625 58.125 68.25 58.125H74.75C76.5375 58.125 78 56.8172 78 55.2188V49.4062C78 47.8078 76.5375 46.5 74.75 46.5H68.25ZM13 72.6562V78.4688C13 80.0672 14.4625 81.375 16.25 81.375H22.75C24.5375 81.375 26 80.0672 26 78.4688V72.6562C26 71.0578 24.5375 69.75 22.75 69.75H16.25C14.4625 69.75 13 71.0578 13 72.6562ZM42.25 69.75C40.4625 69.75 39 71.0578 39 72.6562V78.4688C39 80.0672 40.4625 81.375 42.25 81.375H48.75C50.5375 81.375 52 80.0672 52 78.4688V72.6562C52 71.0578 50.5375 69.75 48.75 69.75H42.25ZM65 72.6562V78.4688C65 80.0672 66.4625 81.375 68.25 81.375H74.75C76.5375 81.375 78 80.0672 78 78.4688V72.6562C78 71.0578 76.5375 69.75 74.75 69.75H68.25C66.4625 69.75 65 71.0578 65 72.6562Z",
    fill: "#264A80",
    fillOpacity: 0.68
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYears);
export default __webpack_public_path__ + "static/media/years.5b9b38ab6fbbd25960b8048e3b12d741.svg";
export { ForwardRef as ReactComponent };